









import { Component, Prop, Vue } from 'vue-property-decorator';
import store from '@/store';

@Component({})
export default class HubSpotHiddenFields extends Vue {
    @Prop() public userData: any;

    public inputs = [
        {
            name: 'optin_marketing',
            target: 'is_subscribed',
        },
        {
            name: 'optin_profilazione',
            target: 'pu_gdpr_profiling',
        },
        {
            name: 'optin_privacy',
            target: 'pu_gdpr_privacy',
        },
        {
            name: 'store_view',
            value: store.state.options.store_code.split('_')[1].toUpperCase(),
        },
        {
            name: 'page_name',
            value: document.title,
        },
    ];
}
